import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18next from "i18next";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { ChatApi } from "states/api/chat";

export default function Service() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {
    authStore: { token, general },
  } = useStores();

  const { mutate: onRead, isLoading } = useMutation(
    () => ChatApi.onRead({ params: {} }),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries(["get_profile"]);
      },
    }
  );

  useEffect(() => {
    onRead();
  }, []);

  return (
    <div className="min-h-[100vh] bg-[#000] container pt-[60px] mx-auto">
      <HeaderTop title={i18next.t("contact_us")} />
      <iframe
        src={`${general?.link_support}?token=${token}`}
        title="CSKH"
        key="cskh"
        className="cskh-iframe"
        width="100%"
      />
    </div>
  );
}
